import * as core from './core'
import * as builder from './builder'

export default Object.assign({}, core, builder)
